import React from "react";

export const getSeatDescription = (seat, currency, feeRate = 0, fixedFeeRate = 0, isFee = false, isShowPrice = true) => {
  let description = <>No Seat</>;

  if (seat.area) {
    description = <>{seat.area}-{seat.side}-{seat.row}-{seat.seat}</>;
  }

  if (seat.ticketTemplate.ticketName) {
    description = <b>{seat.ticketTemplate.ticketName }, {description} </b>;
  }

  const price = isFee ? seat.price * (1 + feeRate) + fixedFeeRate : seat.price;

  return (
    <div>
      {description}
      {isShowPrice && (
        <div>
          <strong>Refund amount: </strong>
          {price}{' '}{currency}
        </div>
      )}
    </div>
  );
};
